<script>
	import CommonHelper from "./CommonHelper";
	import store from "../../store.js";

	export default {
		requestResources: function(params){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/UserMessages/PostMessage/"; // TODO: kažkur iškelti...
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							var msgContent = [
								params.typePretty,
								params.value,
								params.message
							];
							CommonHelper.sendEmail(1, msgContent);
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		updateUserMessage: function(params){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/UserMessages/UpdateMessage/"; // TODO: kažkur iškelti...
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		getCommonSettings: function(){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/AtlasParameters/GetMainParameters/"; // TODO: kažkur iškelti...
				setTimeout(function(){
					window.fetch(url, {
						method: "POST"
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var data;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										if (json["mainParameters"]) {
											data = {
												settings: json["mainParameters"],
												updateDate: json["mainParameters"]["UpdateData"]
											};
											delete data.settings["UpdateData"];
										}
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (data) {
							resolve(data);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		getUserMessages: function(){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/UserMessages/GetMessage/"; // TODO: kažkur iškelti...
				setTimeout(function(){
					window.fetch(url, {
						method: "POST"
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var messages;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										messages = json["userMessages"];
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (messages) {
							resolve(messages);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		updateCommonSettings: function(params){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/AtlasParameters/updateMainParameters"; // TODO: kažkur iškelti...
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		getAttributeTitle: function(key){
			var titles = {
				MaxAll: "Visų tipų papildomi resursai",
				MaxInteractiveAtlas: "Maksimalus interaktyvių atlasų skaičius",
				MaxPrintAtlas: "Maksimalus spausdinamų atlasų skaičius",
				MaxMb: "Duomenų limitas (Mb)",
				AdminEmail: "Administratoriaus el. pašto adresas",
				Other: "Kitas",
				closed: "uždaryta",
				submitted: "pateikta",
				approved: "patvirtinta",
				rejected: "atmesta",
				inProgress: "vykdoma"
			};
			var title = titles[key] || key;
			return title;
		},
        getAdminAtlasList: function () {
            var promise = new Promise(function (resolve, reject) {
                var url = "/atlas/api/GetAdminAtlasList"; // TODO: kažkur iškelti...
                setTimeout(function () {
                    window.fetch(url, {
                        method: "POST"
                    }).then(function (response) {
                        if (response.status == 200) {
                            return response.text();
                        } else {
                            reject();
                        }
                    }).then(function (text) {
                        var atlases;
                        if (text) {
                            try {
                                var json = JSON.parse(text);
                                if (json) {
                                    if (json.success) {
                                        atlases = json["atlases"];
                                    }
                                }
                            } catch (err) {
                                // ...
                            }
                        }
                        if (atlases) {
                            resolve(atlases);
                        } else {
                            reject();
                        }
                    }.bind(this), function () {
                        reject();
                    });
                }.bind(this), store.state.testDelay);
            });
            return promise;
        },
		getUserParameters: function(userName){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/AtlasParameters/getUserParameters"; // TODO: kažkur iškelti...
				var params = {
					user: userName
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var userParameters;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										userParameters = json["userParameters"];
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (userParameters) {
							resolve(userParameters);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		updateUserParameters: function(params, create){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/AtlasParameters/"; // TODO: kažkur iškelti...
				if (create) {
					url += "CreateUserParameters";
				} else {
					url += "UpdateUserParameters";
				}
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve(success);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		deleteUserParameters: function(userName){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/AtlasParameters/DeleteUserParameters"; // TODO: kažkur iškelti...
				var params = {
					user: userName
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve(success);
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		}
	}
</script>